<template>
  <Popover ref="popover" :showHeader="true" headerTitle="Order Item Legend" sizeClass="popover-medium">
    <div class="legend-content">
      <h4>Order Item Types</h4>
      <div class="pl-1">
        <div class="legend-line">
          <i class="fal fa-fw fa-layer-group"></i> Non-processed stock glass order item
        </div>
        <div class="legend-line">
          <i class="fal fa-fw fa-tools"></i> Processed glass order item
        </div>
      </div>
      <div class="my-1">&nbsp;</div>

      <h4>Order Item Status</h4>
      <div class="pl-1">
        <div class="legend-line">
          <i class="fas fa-fw fa-circle tasks-order-item-status-icon not-ready"></i> Order item has no panels ready
        </div>
        <div class="legend-line">
          <i class="fas fa-fw fa-circle tasks-order-item-status-icon mixed"></i> Order item has some panels ready for despatch
        </div>
        <div class="legend-line">
          <i class="fas fa-fw fa-circle tasks-order-item-status-icon ready"></i> Order item is fully ready for despatch
        </div>
        <div class="legend-line">
          <i class="fas fa-fw fa-check-circle tasks-order-item-status-icon ready"></i> Order item is despatched &amp; completed
        </div>        
      </div>
    </div>
  </Popover>
</template>

<style scoped>
.legend-content {
  padding: 0.5rem;
}
.legend-content > h4 {
  margin-top: 0;
  margin-bottom: -0.25rem;
}
.legend-line {
  clear: both;
  font-size: 13px;
  padding-top: 6px;
}
.legend-line > .legend-icon {
  float: left;
  width: 35px;    
}
.legend-line > .legend-text {
  float: left;
  width: calc(100% - 35px);
}
</style>


<script>
import Popover from '@/components/popover.vue'

export default {
  name: 'OrderLegendPopover',
  components: {
    Popover
  },
  methods: {
    displayFromElement(element) {
      this.$refs.popover.displayFromElement(element)
    },
  }
}
</script>
